import { randomInteger } from 'remeda'

const COLORS = [
  '#f50072',
  '#e63298',
  '#cf50b6',
  '#b067cc',
  '#8d78d7',
  '#6b85d9',
  '#4f8fd3',
  '#4495c7',
  '#ff5ca8',
  '#e774d0',
  '#c38bec',
  '#9a9ffb',
  '#74aefc',
  '#5bbaf3',
  '#5dc2e4',
  '#009fcd',
  '#00a8ce',
  '#00b1c9',
  '#00b9bf',
  '#00c0b0',
  '#00c69d',
  '#0bcb86',
  '#57c976',
  '#94c361',
  '#bebc5d',
  '#dcb469',
]

export function getRandomBrandColor(colors = COLORS): string {
  const color = colors[randomInteger(0, colors.length - 1)]
  if (!color) {
    throw new Error('No colors available')
  }
  return color
}

export const DEFAULT_COLORS = [
  '#F50072',
  '#FF5CA8',
  '#73C7D4',
  '#4495C7',
  '#3BCEAC',
  '#0BCB86',
  '#DCB469',
  '#DDCEA6',
]

export const FLAG_COLORS = {
  red: '#F50072',
  doubleBubble: '#FF5CA8',
  skyBlue: '#73C7D4',
  celestial: '#4495C7',
  turquoise: '#3BCEAC',
  viridian: '#0BCB86',
  earthYellow: '#DCB469',
  dutchWhite: '#DDCEA6',
}
